import React, { useEffect, useState } from 'react';
import { loadPlaceBanner } from '../../../services/services/AdsService';
import SmallBanner from './SmallBanner';
import Cookies from 'js-cookie';
import { isEmpty } from '../../../services/utils/utils';
import { analyticsBannerClick, analyticsBannerLoad, analyticsBannerShow } from '../../../services/analytics/analyticsBanners';
var Platform;
(function (Platform) {
    Platform["DESKTOP"] = "DESKTOP";
    Platform["TABLET"] = "TABLET";
    Platform["MOBILE"] = "MOBILE";
})(Platform || (Platform = {}));
var SmallBanners = function (_a) {
    var deviceWidth = _a.deviceWidth, lang = _a.lang, profile = _a.profile;
    var _b = useState([]), smallBanners = _b[0], setSmallBanners = _b[1];
    var _c = useState(false), isSmallBannersLoaded = _c[0], setIsSmallBannersLoaded = _c[1];
    var _d = useState(false), isSmallBannersShowed = _d[0], setIsSmallBannersShowed = _d[1];
    var _e = useState(deviceWidth >= 1008 ? Platform.DESKTOP : (deviceWidth < 1008 &&
        deviceWidth >= 768 ? Platform.TABLET : Platform.MOBILE)), platform = _e[0], setPlatfrom = _e[1];
    var ecomParamsForGA = function (items) {
        if ((items === null || items === void 0 ? void 0 : items.length) > 1) {
            return items.map(function (item) {
                var code = item.code;
                return {
                    item_id: code,
                    item_name: 'banner',
                    item_variant: 'card',
                    location_id: 's7_main',
                };
            });
        }
        return [{
                item_id: (items === null || items === void 0 ? void 0 : items.code) || '',
                item_name: 'banner',
                item_variant: 'card',
                location_id: 's7_main',
            }];
    };
    useEffect(function () {
        if (deviceWidth >= 1008) {
            setPlatfrom(Platform.DESKTOP);
        }
        else if (deviceWidth < 1008 && deviceWidth >= 768) {
            setPlatfrom(Platform.TABLET);
        }
        else {
            setPlatfrom(Platform.MOBILE);
        }
    }, [deviceWidth]);
    useEffect(function () {
        var isAuth = Cookies.get('isAuth') == 1;
        var options = {
            lang: lang,
            place: 'CARD_BANNERS',
            platform: platform,
            ssdkl: Cookies.get('ssdkl'),
            profile: profile && profile.id ? profile.id : ''
        };
        if (!isEmpty(profile) || !isAuth) {
            loadPlaceBanner(options).then(function (data) {
                setIsSmallBannersLoaded(true);
                if (!isEmpty(data)) {
                    analyticsBannerLoad(ecomParamsForGA(data));
                }
                setSmallBanners(data);
            }).catch(function (e) {
                console.log(e);
            });
        }
        else if (isSmallBannersLoaded === false) {
            loadPlaceBanner(options).then(function (data) {
                setIsSmallBannersLoaded(true);
                if (!isEmpty(data)) {
                    analyticsBannerLoad(ecomParamsForGA(data));
                }
                setSmallBanners(data);
            }).catch(function (e) {
                console.log(e);
            });
        }
    }, [platform, profile]);
    if (isEmpty(smallBanners)) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null, smallBanners.map(function (item, i) {
        if (!isSmallBannersShowed && i == ((smallBanners === null || smallBanners === void 0 ? void 0 : smallBanners.length) - 1)) {
            analyticsBannerShow(ecomParamsForGA(smallBanners));
            setIsSmallBannersShowed(true);
        }
        return (React.createElement("div", { key: item.id, className: 'mainpage-special-places__item' },
            React.createElement(SmallBanner, { data: item, onBannerClick: function () { return analyticsBannerClick(ecomParamsForGA(item)); } })));
    })));
};
export default SmallBanners;
